export default {"src":"/_next/static/media/check-box-mark.d8a84a9d.svg","height":20,"width":20};